import { render } from "./StepTwoAlternativeExistingCustomerDetailsView.vue?vue&type=template&id=b1f71acc"
import script from "./StepTwoAlternativeExistingCustomerDetailsView.vue?vue&type=script&lang=js"
export * from "./StepTwoAlternativeExistingCustomerDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__